<template>
  <div id="app">
    <ykc-theme :target="target" :themes="themes">
      <router-view v-if="isRouterAlive"></router-view>
    </ykc-theme>
  </div>
</template>

<script>
  import { localSetItem, localGetItem } from '@/utils';
  import allThemes from '@/components/ykc-ui/styles';

  export default {
    name: 'App',
    provide() {
      return {
        reload: this.reload,
        changeTheme: this.changeTheme,
      };
    },
    data() {
      return {
        isRouterAlive: true,
        target: window.document.body,
        themes: allThemes.lightTheme,
      };
    },
    mounted() {
      this.setTheme();
    },
    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(() => {
          this.isRouterAlive = true;
        });
      },
      setTheme() {
        const theme = localGetItem('themeMode') || 'lightTheme';
        this.themes = allThemes[theme] || allThemes.lightTheme;
      },
      /**
       *
       * @param {*} mode lightTheme darkTheme
       */
      changeTheme() {
        const theme = localGetItem('themeMode') || 'lightTheme';
        const nextTheme = theme === 'lightTheme' ? 'darkTheme' : 'lightTheme';
        localSetItem('themeMode', nextTheme);
        this.themes = allThemes[nextTheme];
      },
    },
  };
</script>

<style lang="scss">
  @import '@/assets/css/base.scss';
  html,
  body {
    height: 100vh;
    width: 100vw;
    margin: 0;
    padding: 0;
    background-color: var(--theme-bg-gray);
    color: var(--theme-text-primary);
    font-size: var(--theme-font-normal);
  }

  #app {
    height: 100%;
    width: 100vw;
    box-sizing: border-box;
  }

  .motorcade-main-account {
    height: 100%;
  }

  .table-header-button {
    .el-button {
      margin-left: 8px !important;
    }
  }

  .drawer-button-wrap {
    padding: 0 10px;
    button {
      margin-right: 8px !important;
    }
  }
</style>
